import { render, staticRenderFns } from "./MonoIGStrokeIcon.vue?vue&type=template&id=70f2c0c4&scoped=true"
import script from "./MonoIGStrokeIcon.vue?vue&type=script&lang=js"
export * from "./MonoIGStrokeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f2c0c4",
  null
  
)

export default component.exports